module.exports = __webpack_public_path__ + "static/media/298265.e98596c1.png";